<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <ng-select [(ngModel)]="selectedRelationValues"
                       bindLabel="text"
                       bindValue="id"
                       [clearable]="false"
                       [multiple]="true"
                       [items]="relationsValues"
                       (add)="selected()"
                       (remove)="removed()"></ng-select>
        </div>
    </div>
    <div class="row"
         style="margin-top: 1rem">
        <div class="col-md-6">
            <primary-text-button (onClick)="onSave.emit()">{{'Save' | translate }}</primary-text-button>
        </div>
        <div class="col-md-6">
            <cancelary-text-button (onClick)="onCancel.emit()">{{'Cancel' | translate }}</cancelary-text-button>
        </div>
    </div>
</div>
